import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '@prisjakt/ui-app-context';

type Props = {
  children: React.ReactNode;
  to: string;
};

export const CtxLink = memo((props: Props) => {
  const { renderMode } = useAppContext();
  const legacyRenderMode = ['desktop', 'mobile', 'native'].includes(renderMode);

  if (legacyRenderMode) {
    return <a href={props.to}>{props.children}</a>;
  }
  return <Link to={props.to}>{props.children}</Link>;
});
